import PropTypes from "prop-types";
import { memo, useRef } from "react";
import Merchandising from "app/pages/Listing/merchandising/Merchandising";
import { RESOLUTION } from "app/constants";
import { resolutionPropType } from "app/utils/propTypes";
import "./triple-merchandising-carousel.scss";
import get from "lodash/get";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import SimpleProgressiveImg from "app/pages/.shared/SimpleProgressiveImg";
import Loader from "app/pages/.shared/Loader";
import { ArrowRightIcon, ArrowLeftIcon } from "app/icons/navigation";

const IMG_SIZES = {
	large: { width: 500, height: 438 },
	medium: { width: 500, height: 438 },
	xlarge: { width: 500, height: 438 },
	small: { width: 500, height: 438 },
};

const resolutionParams = {
	[RESOLUTION.XLARGE]: {
		slidesPerView: 3,
	},
	[RESOLUTION.LARGE]: {
		slidesPerView: 3,
	},
	[RESOLUTION.MEDIUM]: {
		slidesPerView: 2.2,
	},
	[RESOLUTION.SMALL]: {
		slidesPerView: 1.5,
	},
};

const TripleMerchandisingCarousel = ({ merchandisingList, resolution }) => {
	const prevRef = useRef(null);
	const nextRef = useRef(null);

	const handleSwiper = swiper => {
		swiper.params.navigation.prevEl = prevRef.current;
		swiper.params.navigation.nextEl = nextRef.current;
		swiper.navigation.init();
		swiper.navigation.update();
	};

	let carouselHeight = "auto";

	if (
		resolution === RESOLUTION.LARGE ||
		resolution === RESOLUTION.XLARGE ||
		resolution === RESOLUTION.MEDIUM
	) {
		carouselHeight = "293.16px";
	} else if (resolution === RESOLUTION.SMALL) {
		carouselHeight = "200px";
	}

	const isServerSide = typeof window === "undefined";

	return isServerSide ? (
		<div
			style={{
				minHeight: carouselHeight,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Loader />
		</div>
	) : (
		<div style={{ minHeight: carouselHeight }}>
			<div
				ref={prevRef}
				className="triple-merchandising-carousel__button triple-merchandising-carousel__button--previous"
			>
				<ArrowLeftIcon className="icon icon--previous" />
			</div>
			<div
				ref={nextRef}
				className="triple-merchandising-carousel__button triple-merchandising-carousel__button--next"
			>
				<ArrowRightIcon className="icon icon--next" />
			</div>
			<Swiper
				className="triple-merchandising-carousel"
				modules={[Navigation]}
				navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
				onSwiper={handleSwiper}
				spaceBetween={10}
				loop={true}
				{...resolutionParams[resolution]}
			>
				{merchandisingList.map(merchandising => {
					let imageSrc = false;

					if (
						resolution === RESOLUTION.LARGE ||
						resolution === RESOLUTION.XLARGE ||
						resolution === RESOLUTION.MEDIUM
					) {
						imageSrc = get(merchandising, "photoLarge.url");
					} else if (resolution === RESOLUTION.SMALL) {
						imageSrc = get(merchandising, "photoSmall.url");
					}

					const merchKey = `${merchandising.code}-${merchandising.startAt}`;

					return (
						<SwiperSlide key={merchKey}>
							<Merchandising
								forceClickOnPicture={true}
								imageElement={
									<SimpleProgressiveImg
										resolution={resolution}
										sizes={IMG_SIZES}
										src={imageSrc}
									/>
								}
								merchandisingCode={merchandising.code}
								position={merchandising.position}
								indexCarousel={merchandising.headerIndex}
								endAt={merchandising.endAt}
								countdownPosition={get(merchandising, "countdown.position")}
								countdownTextColor={get(merchandising, "countdown.textColor")}
								countdownStartAt={get(merchandising, "countdown.startAt")}
								countdownEndAt={get(merchandising, "countdown.endAt")}
								daysInHours={get(merchandising, "countdown.daysInHours")}
								redirectUrl={get(merchandising, "redirectUrl")}
							/>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</div>
	);
};

TripleMerchandisingCarousel.propTypes = {
	merchandisingList: PropTypes.arrayOf(PropTypes.object),
	resolution: resolutionPropType,
};

TripleMerchandisingCarousel.defaultProps = {
	merchandisingList: [],
};

export default memo(TripleMerchandisingCarousel);
